const MD_MIN = '(min-width: 768px)';

function syncManageInert(el: HTMLDetailsElement): void {
  const manage = el.querySelector<HTMLElement>('.sample-row-manage');
  if (!manage) return;
  if (el.open) manage.removeAttribute('inert');
  else manage.setAttribute('inert', '');
}

/**
 * md+: 行の「その他」details を open にして詳細/編集/削除を横並び表示。
 * xs: 閉じ、manage に inert（閉じた details でも a11y に漏れないようにする）。
 */
export function syncSampleRowMoreOpenForViewport(
  root: ParentNode = typeof document !== 'undefined' ? document : (null as unknown as ParentNode)
): void {
  if (typeof window === 'undefined' || !root) return;
  const openOnMd = window.matchMedia(MD_MIN).matches;
  root.querySelectorAll<HTMLDetailsElement>('details.sample-row-more').forEach((el) => {
    if (!el.dataset.moreBound) {
      el.dataset.moreBound = '1';
      el.addEventListener('toggle', () => syncManageInert(el));
    }
    el.open = openOnMd;
    syncManageInert(el);
  });
}
